/*
 * ⚠️ `#fff` осознанно — та же причина, что у плитки мессенджера в переписке: внутри бренд-иконки
 * (лого WhatsApp, Telegram), и белое на фирменном цвете — часть самого лого, а не наш выбор краски.
 * `var(--on-accent)` нарисовал бы в тёмной теме ТЁМНЫЙ значок WhatsApp. Литерал объявлен поимённо
 * в `tools/contrast.mjs` (`ЛИТЕРАЛЫ_ПО_ДЕЛУ`) — без этой записи скан литералов роняет сборку.
 */
.root {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: var(--tint);
  color: #fff;
}

/* Почти белая плитка (`--sunk` у почты): белая иконка на ней утонула бы. */
.pale {
  color: var(--ink-2);
}
